export default __webpack_public_path__ + "static/media/search.bda0ba7e.svg";